import {MultimediaImageLazy} from 'app/components/multimedia/image/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineMultimediaImage(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-multimedia-image')) {
        return;
    }

    customElements.define(
        'gem-multimedia-image',
        class extends WebComponentLoader {
            reactLazyComponent = MultimediaImageLazy;
        },
    );
}
